import { BaseEntity } from '@smartera/core';

export interface AnalyzeFunctionExecutionLog extends BaseEntity {
	analyzeFunctionDefinitionId: string;
	analyzeFunctionDefinitionCode: string;
	status: AnalyzeFunctionExecutionLogStatus;
	startTime: Date;
	endTime: Date;
	executionResult: {
		data: string;
	};
	functionParameters: {
		data: string;
	};
	query: {
		data: string;
	};
}

// executionResult.data
export type AnalyzeFunctionExecutionLogData = { [key: string]: string | number }[];

export enum AnalyzeFunctionExecutionLogStatus {
	COMPLETED = 'COMPLETED',
	FAILED = 'FAILED',
	STARTED = 'STARTED',
}
